import { render, staticRenderFns } from "./harmfulFactorsPop.vue?vue&type=template&id=d0286fca"
import script from "./harmfulFactorsPop.vue?vue&type=script&lang=js"
export * from "./harmfulFactorsPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0286fca')) {
      api.createRecord('d0286fca', component.options)
    } else {
      api.reload('d0286fca', component.options)
    }
    module.hot.accept("./harmfulFactorsPop.vue?vue&type=template&id=d0286fca", function () {
      api.rerender('d0286fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/wmr/harmfulFactorsPop.vue"
export default component.exports